var _rect, _g, _text, _text2, _line, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 80,
    viewBox: "0 0 200 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 80,
    rx: 8,
    fill: "#004A99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10,
    width: 8,
    height: 40,
    rx: 2,
    fill: "#E32636"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 4,
    height: 4,
    fill: "#1E73BE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 12,
    height: 6,
    rx: 3,
    fill: "#1E73BE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    r: 2,
    cy: 18,
    fill: "#E32636"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 52,
    r: 1,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 54,
    r: 0.8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 55,
    r: 0.6,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 57,
    r: 0.5,
    fill: "#FFFFFF"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 35,
    fontFamily: "Montserrat, sans-serif",
    fontWeight: 800,
    fontSize: 18,
    fill: "#FFFFFF"
  }, "\n    MULTINYECTORES\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 52,
    fontFamily: "Poppins, sans-serif",
    fontWeight: 500,
    fontSize: 10,
    fill: "#1E73BE",
    opacity: 0.9
  }, "\n    INYECCI\xD3N ELECTR\xD3NICA\n  ")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 57,
    x2: 180,
    y2: 57,
    stroke: "#E32636",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 20)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15,
    height: 2,
    fill: "#1E73BE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 2,
    height: 8,
    fill: "#1E73BE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 8,
    height: 2,
    fill: "#1E73BE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 2,
    fill: "#E32636",
    opacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.723368d66b83dea5f804b04a60f1a50c.svg";
export { ForwardRef as ReactComponent };